export default {
    "lang": "阿拉伯语",
    application: {
        name: 'نظام نشر المعلومات',
    },
    ajaxTip: {
        success: 'نجاح',
        error: 'فشل',
        noAccess: 'لا يوجد حق الوصول إلى هذا المورد',
        notFound: 'المورد المطلوب غير موجود',
        serverBusy: 'الخادم مشغول',
        timeOut: 'انتهت مهلة الطلب',
    },
    menu: {
        home: 'الصفحة الرئيسية',
        template: 'إدارة القوالب',
        program: 'إدارة البرامج',
        playplan: 'خطة التشغيل',
        device: 'إدارة الأجهزة',
        "source-material": 'إدارة المواد الخام',
        material: 'المواد الخام',
        checkManage: 'إدارة المراجعة',
        setting: 'الإعدادات',
        usercenter: "مركز المستخدم",
        adminManage: "إدارة الأجهزة",
        schedule: "المهام المعلقة",
        capitalassets: "إدارة الأصول",
        modifyPassword: "تغيير كلمة المرور",
        logout: "تسجيل الخروج",
        "add": "إضافة",
        "edit": "تعديل",
        "delete": "حذف",
        "view": "عرض",
        "menu_1": "الصفحة الرئيسية",
        "menu_2": "إدارة الأجهزة",
        "menu_3": "تعديل (الإعدادات المتقدمة - التعديل الأساسي - تغيير الشبكة)",
        "menu_4": "الأوامر الفورية",
        "menu_5": "تعديل (نقل القسم)",
        "menu_6": "الاستراتيجية",
        "menu_7": "إعدادات الصوت",
        "menu_8": "إعدادات السطوع",
        "menu_9": "إعدادات التنزيل",
        "menu_10": "إعدادات السكون",
        "menu_11": "خصائص الجهاز",
        "menu_12": "تعديل/إضافة",
        "menu_13": "إدارة البرامج",
        "menu_14": "تاريخ النشر",
        "menu_15": "حذف (جماعي/منفرد)",
        "menu_16": "البرامج في حالة النشر",
        "menu_17": "تجميع",
        "menu_19": "قائمة البرامج",
        "menu_20": "تعديل المحتوى",
        "menu_21": "نسخ البرنامج",
        "menu_23": "نشر البرنامج",
        "menu_24": "إدارة المواد",
        "menu_25": "رفع",
        "menu_28": "نشر سريع",
        "menu_29": "إدارة القوالب",
        "menu_30": "القوالب العامة",
        "menu_31": "استخدام فوري",
        "menu_32": "قوالي الخاصة",
        "menu_33": "نشر إلى القوالب العامة",
        "menu_35": "سجل المشاركة",
        "menu_36": "إدارة المراجعة",
        "menu_37": "مراجعة البرامج",
        "menu_38": "مراجعة (موافقة/رفض)",
        "menu_39": "مراجعة المواد",
        "menu_41": "تاريخ المراجعة (المشغل)",
        "menu_42": "تاريخ المراجعة (المراجع)",
        "menu_43": "عرض عدد الموافقات",
        "menu_44": "إدارة المنظمة",
        "menu_45": "إدارة السجلات",
        "menu_46": "سجلات التشغيل",
        "menu_47": "سجلات النشر",
        "menu_48": "سجلات الأخطاء",
        "menu_49": "سجلات العمليات",
        "menu_50": "سجلات الملفات",
        "menu_51": "سجلات الدخول",
        "menu_52": "موافقة المحتوى",
        "menu_53": "مساحة التخزين",
        "menu_54": "هيكل المنظمة",
        "menu_55": "أذونات الأدوار",
        "menu_56": "تمكين الصلاحيات",
        "menu_57": "عرض (أذونات التمكين)",
        "menu_58": "أعضاء المنظمة",
        "menu_60": "إعادة تعيين كلمات مرور المستخدمين التابعين",
        "menu_61": "إدارة الأصول",
        "menu_62": "رصيدي",
        "menu_63": "عرض (تفاصيل الأموال)",
        "menu_64": "تدفقي البيانات",
        "menu_65": "عرض (تفاصيل تدفق البيانات)",
        "menu_66": "شراء تدفق البيانات",
        "menu_67": "سعري التخزين",
        "menu_68": "أجهزتي",
        "menu_69": "تفاصيل الطلب",
        "menu_70": "عرض (إعادة شحن)",
        "menu_71": "عرض (القوالب المشتراة)",
        "menu_72": "عرض (تدفق البيانات المشتراة)",
        "menu_73": "أذونات أخرى",
        "menu_74": "عرض (إحصاءات المواد والبرامج)",
        "menu_75": "عرض (الأصول)",
        "menu_76": "عرض (تدفق البيانات السحابي/الإحصاءات)",
        "menu_77": "عرض (إحصاءات الأجهزة المتصلة بالإنترنت)"
    },
    login: {
        terminalServiceSystem: 'نظام خدمة الطرفية الذكي',
        accountLogin: 'تسجيل الدخول بحساب',
        register: 'التسجيل',
        accountLoginTip: 'تسجيل الدخول بحساب موجود',
        scanQRCode: 'يرجى مسح رمز الاستجابة السريعة',
        readAndAgree: 'لقد قرأت ووافقت',
        readAndAgreeLink: 'اتفاقية خدمة المستخدم',
        readAndAgreeAgreement: 'يرجى قراءة ووافقة على اتفاقية خدمة المستخدم',
        forgetpassword: "نسيت كلمة المرور؟",
        resetpassword: "إعادة تعيين كلمة المرور",
        phoneEmptyTip: "يرجى إدخال رقم الهاتف المحمول",
        nextStep: "الخطوة التالية",
        title: 'مرحبا بكم في تسجيل الدخول',
        submit: 'تسجيل الدخول',
        userName: 'الحساب',
        password: 'كلمة المرور',
        userNameEmptyTip: 'يرجى إدخال اسم المستخدم',
        passwordEmptyTip: 'يرجى إدخال كلمة المرور',
        passwordFormatTip: 'يرجى إدخال تنسيق كلمة المرور الصحيح',
        passwordIsOk: 'يرجى إدخال تأكيد كلمة المرور',
        passwordSign: 'يرجى إدخال كلمة المرور',
        codeTip: "يرجى إدخال رمز التحقق",
        phone: "رقم الهاتف المحمول لا يمكن أن يكون فارغاً",
        code: "رمز التحقق لا يمكن أن يكون فارغاً",
        nickname: "اسم الشركة لا يمكن أن يكون فارغاً",
        pass: "كلمة المرور لا يمكن أن تكون فارغة",
        pwdMessage: "طول كلمة المرور 8~20 حرفًا، لا يمكن أن يحتوي على مسافات ويجب أن يحتوي على 3 من أنواع الأحرف التالية: أحرف كبيرة، أحرف صغيرة، أرقام، أحرف خاصة",
        pwdMessage01: "يرجى إدخال كلمة مرور تتكون من أحرف وأرقام وطولها أكثر من 8 أحرف",
        pwdMessage02: "طول كلمة المرور 8-20 حرفًا",
        pwdMessage03: "كلمة المرور لا يمكن أن تحتوي على مسافات",
        pwdMessage04: "كلمة المرور يجب أن تحتوي على ثلاثة من بين الأحرف الكبيرة، الأحرف الصغيرة، الأرقام، الرموز",
        newpassempty: "كلمة المرور الجديدة لا يمكن أن تكون فارغة",
        newpass: "كلمات المرور غير متطابقة في المرة الثانية",
        getcode: "الحصول على رمز التحقق",
        format: "تنسيق رقم الهاتف المحمول غير صحيح",
        chongfa: "إعادة الإرسال بعد ثوانٍ",
        isSend: 'تم الإرسال',
        noregister: "لا يوجد حساب؟ سجل الآن",
        Mobile: "رقم الهاتف المحمول",
        verificationcode: "رمز التحقق",
        petname: "اللقب",
        Quickregistration: "التسجيل السريع",
        xiugaimima: "تغيير كلمة المرور",
        jiumima: "كلمة المرور القديمة",
        xinmima: "كلمة المرور الجديدة",
        zaicishuruxinmima: "أعد إدخال كلمة المرور الجديدة",
        xiugaichenggong: "تم التعديل بنجاح",
        xiugaishoujihao: "تغيير رقم الهاتف المحمول",
        dengluzhanghao: "حساب تسجيل الدخول",
        gongsiid: "معرف الشركة",
        yonghunicheng: "لقب المستخدم",
        chuangjianshijian: "وقت الإنشاء",
        gongsimingcheng: "اسم الشركة",
        denglumima: "كلمة مرور تسجيل الدخول",
        jianyi: "يوصى باستخدام كلمة مرور م composée من أحرف وأرقام",
        shezhimima: "تعيين كلمة المرور",
        shezhishoujihao: "تغيير/تعيين رقم الهاتف المحمول",
        yibangding: "تم الربط",
        weibangding: "غير مرتبط",
        zhanghuanquan: "أمان الحساب",
        yonghuxinxi: "معلومات المستخدم",
        zhuceSucMsg: 'تهانينا، تم التسجيل بنجاح!',
        verificationcodeSucMsg: "تم إرسال رمز التحقق بنجاح！",
        requiredIsEmpty: "الحقول المطلوبة لا يمكن أن تكون فارغة！",
        emailObj: {
            title: 'البريد الإلكتروني',
            tit: 'تسجيل الدخول بالبريد الإلكتروني',
            tip: 'يرجى إدخال عنوان البريد الإلكتروني',
            formatTip: 'يرجى إدخال تنسيق البريد الإلكتروني الصحيح',
        },
        phoneObj: {
            title: 'رقم الهاتف المحمول',
            tit: 'تسجيل الدخول بالهاتف المحمول',
            tip: 'يرجى إدخال رقم الهاتف المحمول',
            formatTip: 'يرجى إدخال تنسيق رقم الهاتف المحمول الصحيح',
        },
        emailOrPhoneObj: {
            title: 'البريد الإلكتروني أو رقم الهاتف المحمول',
            tit: 'تسجيل الدخول بالبريد الإلكتروني أو رقم الهاتف المحمول',
            tip: 'يرجى إدخال البريد الإلكتروني أو رقم الهاتف المحمول',
            formatTip: 'يرجى إدخال تنسيق البريد الإلكتروني أو رقم الهاتف المحمول الصحيح',
        },
        wechatObj: {
            title: 'ويشات',
            tit: 'تسجيل الدخول بويشات',
        },
        googleObj: {
            title: 'جوجل',
            tit: 'تسجيل الدخول بجوجل',
        },
        confirm: 'تأكيد',
        confirmSubmit: 'تأكيد الإرسال',
        cancel: 'إلغاء',
        close: 'إغلاق',
        bindSucMsg: 'تم الربط بنجاح',
        toContinueBindAccount: 'استمر لإكمال ربط حساب الطرف الثالث',
        bindTip01: 'لا يوجد حساب؟ سجل واحد',
        bindTip02: 'لديك حساب بالفعل',
        bindTip03: 'حساب الطرف الثالث الحالي غير مرتبط بحساب المنصة، يرجى ربط الحساب الموجود أو تسجيل ربط حساب جديد، ويمكنك تسجيل الدخول بسرعة في المرة القادمة.',
        bindTip04: 'ربط الحساب الموجود',
        bindTip05: 'تسجيل ربط حساب جديد',
        bindTip06: 'لقد قمت بالترخيص من الطرف الثالث، أكمل المعلومات التالية لتسجيل الدخول لإكمال الربط',
        bindSubmit: 'إرسال الربط',
        enterAccountTip: 'يرجى إدخال اسم الحساب',
        RegisterAndBind: 'التسجيل والربط',
        loginErr: 'اسم المستخدم أو كلمة المرور خاطئة！',
        usercenter: "مركز المستخدم",
        pleaseInputName: "يرجى إدخال الاسم",
        operationSuccess: "تم العملية بنجاح！",
        edit: "تحرير",
        xiugai: "تعديل",
        userData: "البيانات الشخصية",
        changePassword: "تغيير كلمة المرور",
        account: "الحساب",
        userName01: "اسم المستخدم",
        phoneNumber: "رقم الهاتف المحمول",
        role: "الدور",
        createTime: "وقت الإنشاء",
        genghuang: "تبديل",
        bangding: "ربط",
        unbind: "فك الربط",
        plesaseSelectBindingType: "يرجى اختيار نوع الربط",
        pleaseConfirmCont: "يرجى تأكيد قراءة هذا المحتوى",
        confirmReadCont: "لقد قرأت هذا المحتوى",
        frequentTip: "العملية متكررة جدًا، يرجى المحاولة لاحقًا!",
        zhuxiaoBtn: "إلغاء الحساب",
        zhuxiaoTitle: "إلغاء الحساب",
        querenZhuxiao: "تأكيد الإلغاء",
        jiXu: "استمرار",
        sendCodeBtn: "إرسال رمز التحقق",
        passwordIsNotOldPassword: "تأكيد كلمة المرور مختلف عن كلمة المرور الجديدة المدخلة",
        passwordIsOldPassword: "كلمة المرور المعدلة هي نفسها كلمة المرور الأصلية",
        passFormatError: "يرجى إدخال تنسيق كلمة المرور الصحيح",
        oldPassWord: "كلمة المرور القديمة",
        newPassWord: "كلمة المرور الجديدة",
        inputPlaceholder: 'يرجى الإدخال',
        confirmPassword: "تأكيد كلمة المرور",
        zhuxiaoTip: `
            1、إلغاء الحساب هو عملية غير قابلة للاسترداد، بمجرد إلغاء الحساب، لن تتمكن من تسجيل الدخول واستخدام هذا الحساب أو الحسابات الثالثة المسجلة عبر هذا الحساب، يرجى نسخ جميع المعلومات والبيانات المتعلقة بالحساب بنفسك.
            2、قبل تسجيل هذا الحساب، يرجى التأكد من إفراغ جميع الأصول وغيرها ولا توجد أي نزاعات；بمجرد إلغاء هذا الحساب، يُعتبر أنك تتنازل عن ملكية جميع الأصول والحقوق في هذا الحساب، ولا يمكن استردادها أو إيجادها.
            3、إذا تم إلغاء 3 حسابات مسجلة بنفس رقم الهاتف المحمول بشكل إجمالي، فلن يُسمح بتسجيل حساب جديد بهذا رقم الهاتف المحمول مرة أخرى، كما لن يُسمح بربطه بأي حساب آخر.
            `
    },
    home: {
        title: "الصفحة الرئيسية",
        quickOperation: "العمليات السريعة",
        addDevice: "إضافة جهاز",
        publishProgram: "نشر البرنامج",
        publishMaterial: "نشر المواد الخام",
        makeProgram: "صنع البرنامج",
        uploadMaterial: "رفع المواد الخام",
        todayData: "البيانات اليومية (محدثة كل ساعة)",
        playNumChart: "إحصائية عدد المرات التي تم تشغيلها",
        deviceOnlineStatus: "حالة اتصال الأجهزة بالإنترنت",
        onLineDevice: "الأجهزة المتصلة بالإنترنت",
        unLineDevice: "الأجهزة غير المتصلة بالإنترنت",
        programPlayTime: "إحصائية مدة تشغيل البرنامج",
        downloadSoft: "تنزيل البرنامج",
        adminApp: "واجهة المستخدم للهاتف المحمول",
        playerApp: "طرفية تشغيل نشر المعلومات",
        downloadAdminApp: "انقر للتنزيل من واجهة المستخدم",
        downloadPlayerApp: "انقر للتنزيل من طرفية التشغيل",
        aboutUs: "من نحن",
        userManual: "دليل المستخدم",
        message: "أريد ترك رسالة",
    },
    device: {
        inputPlaceholder: 'يرجى الإدخال',
        selectPlaceholder: 'يرجى الاختيار',
        osTypeStr: 'نظام الطرفية',
        onLineStatus: 'حالة الاتصال بالإنترنت',
        dpi: 'الدقة',
        companyDeptIdName: 'الجهة التابعة',
        deviceGroupIdName: 'المجموعة التابعة',
        editOrMove: 'تحرير/نقل',
        loanOriginationFee: 'رسوم إصدار القرض',
        strategyInfoLook: 'عرض معلومات الاستراتيجية',
        programLook: 'عرض البرنامج',
        addEquipments: 'إضافة أجهزة',
        luminanceSet: 'التحكم في السطوع',
        terminal: 'إعدادات الطرفية',
        transferCompany: 'نقل إلى قسم آخر',
        releasedProgram: 'نشر البرنامج',
        screenshot: 'لقطة الشاشة',
        changeGroup: 'تغيير المجموعة',
        defaultGroup: "المجموعة الافتراضية",
        operation: "العمليات",
        edit: "تحرير",
        saveEdit: "حفظ التحرير",
        add: "إضافة",
        save: "حفظ",
        setting: "الإعدادات",
        program: "البرنامج",
        unbind: "فك الربط",
        sleep: "النوم المتأخر",
        wakeup: "الاستيقاظ",
        restart: "إعادة التشغيل",
        shutdown: "إغلاق الجهاز",
        reportLog: "إرسال السجلات",
        clearPlayData: "مسح بيانات طرفية التشغيل",
        offlineWarn: "هذا الجهاز غير متصل بالإنترنت، يرجى المحاولة مرة أخرى بعد اتصال الجهاز بالإنترنت！",
        confirmUnbind: "تأكيد فك الربط",
        confirmReset: "تأكيد المسح",
        confirmDelete: "تأكيد الحذف",
        delete: "حذف",
        cancelDelete: "إلغاء الحذف",
        confirmResetSuccess: "تم المسح بنجاح",
        confirm: "تأكيد",
        cancel: "إلغاء",
        operationSuccess: "تم العملية بنجاح",
        unbindSuccess: "تم فك الربط بنجاح",
        pleaseSelectDevice: "يرجى اختيار الجهاز",
        pleaseSelectOnlineDevice: "يرجى اختيار الجهاز المتصل بالإنترنت",
        confirmMixOperation: "تتضمن الأجهزة المختارة أجهزة غير متصلة بالإنترنت، هذه الإعدادات لن تنطبق على الأجهزة غير المتصلة بالإنترنت، هل تؤكد الاستمرار في العملية؟",
        pleaseSelectDate: "يرجى اختيار التاريخ",
        reportSuccess: "تم الإرسال بنجاح",
        deviceSetting: "إعدادات الجهاز",
        default: "افتراضي",
        all: "الكل",
        deviceList: "قائمة الأجهزة",
        addDevice: "إضافة جهاز",
        department: "قسم الجهة",
        deviceType: "الدقة",
        osType: "نظام الطرفية",
        onlineState: "حالة الاتصال بالإنترنت",
        online: "متصل بالإنترنت",
        offline: "غير متصل بالإنترنت",
        notActive: "غير منشط",
        search: "يرجى إدخال الكلمة الرئيسية",
        batchOperation: "العمليات الجماعية",
        allDevices: "كل الأجهزة",
        deviceAttribute: "سمات الجهاز",
        selectReportDate: "اختيار تاريخ الإرسال",
        inputName: "يرجى إدخال الاسم",
        inputWidth: "يرجى إدخال العرض",
        inputHeight: "يرجى إدخال الارتفاع",
        inputResolutionRatio: "يرجى إدخال عدد صحيح أكبر من 0！",
        inputSort: "يرجى إدخال الترتيب",
        serialNum: "الرقم التسلسلي",
        name: "الاسم",
        width: "العرض",
        height: "الارتفاع",
        resolutionRatio: "الدقة",
        inputResolutionRatioName: "يرجى إدخال اسم الدقة",
        sort: "الترتيب",
        personal: "شخصي",
        system: "نظام",
        type: "النوع",
        systemDefaultSettingUneditable: "لا يمكن تعديل الإعدادات الافتراضية للنظام!",
        systemDefaultSettingUnDeletable: "لا يمكن حذف الإعدادات الافتراضية للنظام!",
        newz: "إضافة جديدة",
        total: "مجموع",
        totalNum: "بند",
        strategyName: "اسم الاستراتيجية",
        associatedTerminalNum: "عدد الطرفيات المرتبطة",
        createTime: "وقت الإنشاء",
        pleaseSelectStrategy: "يرجى اختيار الاستراتيجية！",
        onlySelectOneData: "يمكن اختيار سجل واحد فقط！",
        downloadStrategy: "تنزيل الاستراتيجية",
        inputStrategyName: "يرجى إدخال اسم الاستراتيجية",
        luminanceControl: "التحكم في السطوع",
        volumeStrategy: "استراتيجية الصوت",
        saveSuccess: "تم الحفظ بنجاح",
        screenAngle: "دوران الشاشة (°)",
        startTime: "وقت البدء",
        endTime: "وقت الانتهاء",
        repeat: "تكرار",
        monday: "الاثنين",
        tuesday: "الثلاثاء",
        wednesday: "الأربعاء",
        thursday: "الخميس",
        friday: "الجمعة",
        saturday: "السبت",
        sunday: "الأحد",
        everyday: "كل يوم",
        downloadSpeed: "سرعة التنزيل",
        inputDownloadSpeed: "يرجى إدخال سرعة التنزيل",
        operator: "العمليات",
        pleaseSelectDeleteData: "يرجى اختيار البيانات المراد حذفها！",
        confirmBatchDelete: "هل تؤكد الحذف الجماعي؟",
        pleaseInputName: "يرجى إدخال الاسم",
        detailSetting: "الإعدادات التفصيلية",
        weekPlan: "خطة الأسبوع",
        specialDateSetting: "إعدادات التواريخ الخاصة",
        weekdayInfo: "اليوم الأسبوعي مطلوب!",
        volumeInfo: "الصوت مطلوب!",
        timeError: "خطأ في اختيار الوقت!",
        editSuccess: "تم العملية التحريرية بنجاح！",
        addSuccess: "تم العملية الإضافية بنجاح！",
        addSpecialPlan: "إضافة خطة استراتيجية خاصة",
        downloadSpeedInfo: "سرعة التنزيل: (0 تعني حظر التنزيل)",
        pleaseSelectStartTime: "يرجى اختيار وقت البدء",
        pleaseSelectEndTime: "يرجى اختيار وقت الانتهاء",
        luminanceError: "يرجى إدخال قيمة سطوع صحيحة！",
        defaultLuminance: "السطوع الافتراضي",
        luminance: "مقدار السطوع",
        defaultLuminanceInfo: "السطوع الافتراضي (100 تعني الأكثر سطوعًا، 0 تعني الأكثر غمقًا)",
        volume: "الصوت",
        saveLuminance: "حفظ السطوع",
        changeSuccess: "تم التغيير بنجاح！",
        changeNetwork: "تبديل الشبكة",
        netName: "اسم الشبكة",
        nameempty: "اسم الشبكة لا يمكن أن يكون فارغاً",
        currentNetwork: "الشبكة الحالية",
        ipAddress: "عنوان IP",
        dailyMode: "وضع كل يوم",
        weeklyMode: "وضع كل أسبوع",
        turnOnTime: "وقت تشغيل الجهاز",
        turnOffTime: "وقت إغلاق الجهاز",
        startSleep: "بدء النوم المتأخر",
        endSleep: "انتهاء النوم المتأخر",
        batchDelInfo: "هل تؤكد حذف العناصر المختارة؟",
        timeCannotBeEmpty: "الوقت لا يمكن أن يكون فارغاً!",
        startUp: "تشغيل الجهاز",
        shutDown: "إغلاق الجهاز",
        volumeSize: "مقدار الصوت",
        defaultVolume: "الصوت الافتراضي (100 تعني الأكبر، 0 تعني الصمت)",
        chooseStartTime: "يرجى اختيار وقت البدء",
        chooseEndTime: "يرجى اختيار وقت الانتهاء",
        saveVolume: "حفظ الصوت",
        screenRotationUnSaved: "دوران الشاشة لم يتم حفظه",
        volumeSettingUnSaved: "إعدادات الصوت لم يتم حفظها",
        luminanceSettingUnSaved: "إعدادات السطوع لم يتم حفظها",
        confirmClosePopup: "هل تؤكد إغلاق هذه النافذة المنبثقة؟",
        volumeSettingSuccess: "تم تعديل الصوت بنجاح",
        luminanceSettingSuccess: "تم تعديل السطوع بنجاح",
        advancedSettingUnSaved: "الإعدادات المتقدمة لم يتم حفظها",
        settingTitle: "إعدادات الطرفية",
        volumeSetting: "إعدادات الصوت",
        luminanceSetting: "إعدادات السطوع",
        downloadSetting: "إعدادات التنزيل",
        sleepSetting: "إعدادات النوم المتأخر",
        onOffSetting: "تشغيل وإغلاق الجهاز المزمن",
        screenRotation: "دوران الشاشة",
        namingError: "خطأ في التسمية، لا يمكن أن يحتوي اسم الملف على مسافات！",
        deleteSuccess: "تم الحذف بنجاح",
        deleteFolder: "حذف المجلد",
        pleaseInputDeviceName: "يرجى إدخال اسم الجهاز",
        pleaseInputDeviceId: "يرجى إدخال معرف الجهاز",
        discoverDevice: "اكتشاف الجهاز",
        deviceId: "معرف الجهاز",
        bound: "تم الربط",
        bind: "ربط",
        noDevice: "لا توجد أجهزة",
        refresh: "تحديث",
        manualAdd: "إضافة يدوية",
        deviceGroup: "تصنيف الأجهزة",
        pleaseSelectGroup: "يرجى اختيار المجموعة！",
        deviceName: "اسم الجهاز",
        goAdd: "الذهاب للإضافة",
        close: "إغلاق",
        bindCountInsufficient: "عدد الربط غير كافٍ، يرجى ترقية عدد الأجهزة ثم إضافتها！",
        displayNumber: "الرقم المعروض",
        groupName: "اسم المجموعة",
        pleaseSelectGroupName: "يرجى ملء اسم المجموعة！",
        moveGroup: "نقل المجموعة",
        longitude: "خط الطول",
        latitude: "خط العرض",
        nationality: "الجنسية",
        province: "المقاطعة",
        city: "المدينة",
        county: "المنطقة",
        outNetIp: "عنوان IP الخارجي",
        inNetIp: "عنوان IP الداخلي",
        companyName: "اسم الشركة",
        Info: "التفاصيل",
        android: "أندرويد",
        win: "ويندوز",
        osVersion: "إصدار النظام",
        softwareVersion: "إصدار البرنامج",
        diskSize: "حجم القرص",
        useSize: "الحجم المستخدم",
        macAddr: "عنوان MAC",
        longitudeLatitudeInfo: "خطوط الطول والعرض يجب أن تكون فارغة في نفس الوقت أو غير فارغة!",
        terminalName: "اسم الطرفية",
        terminalGroup: "مجموعة الطرفية",
        reportJournal: "هل يتم الإرسال",
        systemVersion: "إصدار النظام",
        storageSpace: "المساحة التخزينية",
        resolution: "الدقة",
        runningMemory: "الذاكرة التشغيلية",
        model: "النموذج",
        registerStatus: "حالة التسجيل",
        password: "كلمة المرور",
        passwordInfo: "يرجى إدخال 6 إلى 18 كلمة أو أرقام!",
        group: "المجموعة",
        address: "العنوان",
        remark: "ملاحظات",
        renewalPeriod: "فترة التجديد",
        money: "الرسوم",
        latitudeInfo: "يرجى إدخال خط عرض صحيح!",
        totalPayment: "المبلغ الإجمالي",
        longitudeInfo: "يرجى إدخال خط طول صحيح!",
        setMeal: "الباقة",
        number: "العدد",
        programName: "اسم البرنامج",
        playStatus: "حالة التشغيل",
        playType: "طريقة التشغيل",
        play: "تشغيل",
        pause: "إيقاف مؤقت",
        playTime: "وقت التشغيل",
        programDeleted: "تم حذف البرنامج",
        playSuccess: "تم ترتيب تشغيل البرنامج",
        pauseSuccess: "تم الإيقاف المؤقت بنجاح",
        playCycle: "التكرار الدوري",
        playInsert: "التشغيل الإدخالي",
        withdrawSuccess: "تم السحب بنجاح",
        withdrawInfo: "يرجى اختيار البرنامج المراد سحبه أولاً！",
        programBelong: "البرنامج التابع",
        checkAll: "تحديد الكل",
        batchDel: "حذف جماعي",
        delConfirm: "هل تؤكد حذف العناصر المختارة؟",
        check: "محدد",
        noProgram: "لا توجد برامج",
        details: "التفاصيل",
        screenshotFail: "فشل لقطة الشاشة",
        policyName: "اسم السياسة",
        terminalNum: "عدد الطرفيات المرتبطة",
        powerStrategy: "استراتيجية الطاقة",
        pleaseSelectDepartment: "يرجى اختيار القسم！",
        screenshotControl: "تحكم لقطة الشاشة",
        未激活: "غير منشط",
        已激活: "تم التنشيط",
        未绑定: "غير مرتبط",
        已绑定: "تم الربط",
    },
    programManage: {
        programList: "قائمة البرامج",
        publishProgram: "متابعة نشر البرنامج",
        week1: "الاثنين",
        week2: "الثلاثاء",
        week3: "الأربعاء",
        week4: "الخميس",
        week5: "الجمعة",
        week6: "السبت",
        week7: "الأحد",
        monday: "الاثنين",
        tuesday: "الثلاثاء",
        wednesday: "الأربعاء",
        thursday: "الخميس",
        friday: "الجمعة",
        saturday: "السبت",
        sunday: "الأحد",
        name: "الاسم",
        preview: "معاينة",
        playDeviceNum: "عدد أجهزة التشغيل",
        copyDeviceCode: "انقر للنسخ",
        osType: "نوع النظام",
        playDate: "تاريخ التشغيل",
        playWeek: "الأسبوع الذي يتم تشغيله",
        everyday: "كل يوم",
        start: "بدء",
        end: "نهاية",
        playOperateStatusStr: "حالة النشر",
        playDevice: "جهاز التشغيل",
        downloadView: "عرض التنزيل",
        publisher: "الناشر",
        publishTime: "وقت النشر",
        operation: "العمليات",
        add: "إضافة",
        groupName: "اسم المجموعة",
        selectDevice: "اختيار الطرفية",
        searchDevice: "بحث الطرفية",
        pleaseFillGroupName: "يرجى ملء اسم المجموعة！",
        remarkInfo: "ملاحظات",
        compile: "تحرير",
        withdrawConfirm: "هل تؤكد سحب هذا البرنامج؟",
        confirm: "تأكيد",
        cancel: "إلغاء",
        withdraw: "سحب",
        batchWithdraw: "سحب جماعي",
        batchPublish: "نشر جماعي",
        batchDelete: "حذف جماعي",
        batchOperation: "العمليات الجماعية",
        notUse: "غير مستخدم",
        notChecked: "غير مراجع",
        notPass: "غير ممرور",
        delete: "حذف",
        publishTextLeft: "تم النشر",
        offTextLeft: "تم الإيقاف المؤقت",
        pleaseSelectProgramToMove: "يرجى اختيار البرنامج المراد نقله！",
        pause: "إيقاف مؤقت",
        pauseConfirm: "هل تؤكد الإيقاف المؤقت؟",
        play: "تشغيل",
        downloadUdisk: "تنزيل إلى أقراص USB",
        deviceList: "قائمة الأجهزة",
        groupSelection: "اختيار المجموعة",
        operationSuccess: "تم العملية بنجاح",
        deleteSuccess: "تم الحذف بنجاح",
        selectDate: "اختيار التاريخ",
        publishStatus: "حالة النشر",
        checkStatus: "حالة المراجعة",
        waitAuditing: "في انتظار المراجعة",
        auditPass: "تمت المراجعة بنجاح",
        auditRefuse: "تم رفض المراجعة",
        all: "الكل",
        playStatus: "جاري التشغيل",
        playStatust: "حالة التشغيل",
        pauseStatus: "تم الإيقاف المؤقت",
        notStartStatus: "لم يبدأ بعد",
        resolutionratio: "الدقة",
        totalNum: "بند",
        programName: "اسم البرنامج",
        playStartTime: "وقت بدء التشغيل",
        playEndTime: "وقت انتهاء التشغيل",
        createTime: "وقت الإنشاء",
        nationality: "الجنسية",
        province: "المقاطعة",
        city: "المدينة",
        county: "المنطقة",
        address: "العنوان",
        ip: "عنوان IP",
        location: "الموقع",
        log: "السجلات",
        pleaseFillProgramName: "يرجى ملء اسم البرنامج！",
        selectGroup: "اختيار المجموعة",
        startTime: "وقت البدء",
        endTime: "وقت الانتهاء",
        publishCycle: "دورة النشر",
        publishDeviceNum: "عدد أجهزة النشر",
        pleaseSelectRecord: "يرجى اختيار السجل",
        deviceName: "اسم الطرفية",
        deviceId: "معرف جهاز الطرفية",
        deviceGroupIdName: "المجموعة التابعة",
        notClassified: "غير مصنف",
        osTypeStr: "نظام الطرفية",
        storageSpace: "المساحة التخزينية",
        onLineStatus: "حالة الاتصال بالإنترنت",
        onLine: "متصل بالإنترنت",
        offLine: "غير متصل بالإنترنت",
        sleep: "نوم متأخر",
        unknown: "غير معروف",
        registerStatus: "حالة التسجيل",
        trialPeriod: "فترة التجربة",
        notActive: "غير منشط",
        active: "تم التنشيط",
        parameterError: "المعلمات غير صحيحة!",
        pleaseSelectProgram: "يرجى اختيار البرنامج!",
        pleaseSelectProgramEdit: "يرجى اختيار البرنامج المراد تحريره!",
        confirmWithdrawSelectedProgram: "هل تؤكد سحب البرامج المختارة؟",
        withdrawSuccess: "تم السحب بنجاح",
        allPrograms: "كل البرامج",
        defaultGroup: "المجموعة الافتراضية",
        cannotShareEmptyProgram: "لا يمكن مشاركة برنامج فارغ！",
        onlyShareYourProgram: "يمكنك مشاركة البرامج التي أنشأتها فقط!",
        pleaseSelectProgramEditPublishTime: "يرجى اختيار البرنامج الذي تم تحرير وقت نشره!",
        pleaseSelectDevice: "يرجى اختيار الجهاز!",
        programDetail: "تفاصيل البرنامج",
        errorReason: "سبب الخطأ",
        availableStorageSpaceInsufficient: "المساحة التخزينية المتاحة غير كافية",
        partialDeviceReleaseFailure: "فشل نشر بعض الأجهزة",
        allDeviceReleaseSuccess: "تم نشر جميع الأجهزة بنجاح",
        partialDeviceReleaseSuccess: "تم نشر بعض الأجهزة بنجاح",
        allGroup: "كل المجموعات",
        allProgram: "كل البرامج",
        unGrouped: "غير مصنف في مجموعة",
        replaceProgram: "استبدال البرنامج",
        replaceProgramTip: "سيستبدل البرنامج المنشور حديثًا بيانات البرنامج السابقة الموجهة إلى طرفية التشغيل！",
        screen: "شاشة واحدة / شاشتين",
        singleScreen: "شاشة واحدة",
        doubleScreen: "شاشتين",
        playSetting: "إعدادات التشغيل",
        batchPlaySetting: "تعيين وقت التشغيل جماعيًا",
        individualPlaySetting: "تعيين وقت التشغيل بشكل فردي",
        playTime: "وقت التشغيل",
        daily: "كل يوم",
        weekdays: "من الاثنين إلى الجمعة",
        monthly: "الشهر الحالي",
        advancedSetting: "الإعدادات المتقدمة",
        playProgram: "تشغيل البرنامج",
        searchProgram: "يرجى إدخال الكلمة الرئيسية",
        shareAddressNotExist: "عنوان الرابط غير موجود، يرجى المحاولة مرة أخرى",
        copySuccess: "تم النسخ بنجاح",
        shareLink: "رابط المشاركة",
        publish: "نشر",
        noResource: "لا توجد موارد",
        single: "شاشة واحدة",
        double: "شاشتين",
        time: "الوقت",
        associatedTerminalNum: "عدد الطرفيات المرتبطة",
        default: "افتراضي",
        moveGroup: "نقل المجموعة",
        pleaseSelectGroup: "يرجى ملء اسم المجموعة！",
        copy: "نسخ",
        FUBEN: "نسخة",
        nameempty: "الاسم لا يمكن أن يكون فارغاً",
        whitespace: "خطأ في التسمية، لا يمكن أن يحتوي اسم الملف على مسافات！",
        programWhitespace: "خطأ في التسمية، لا يمكن أن يحتوي اسم البرنامج على مسافات！",
        pleaseSelectResolution: "يرجى اختيار الدقة！",
        dataError: "البيانات غير صحيحة！",
        createProgram: "إنشاء برنامج جديد",
        directCreate: "إنشاء مباشر",
        myTemplate: "قوالبي",
        use: "استخدام",
        free: "مجاني",
        loadMore: "تحميل المزيد",
        confirmDelete: "تأكيد الحذف",
        deleteGroup: "حذف المجموعة",
        notPublished: "غير منشور",
        notPassed: "غير ممرور",
        notUsed: "غير مستخدم",
        confirmDeleteSelectedProgram: "هل تؤكد حذف البرامج المختارة？",
        companyName: "اسم الشركة",
        programCannotDownload: "لا يمكن تنزيل هذا البرنامج！",
        publishMaterial: "نشر المواد الخام",
        playMaterial: "تشغيل المواد الخام",
        pleaseInputMaterialName: "يرجى إدخال اسم المواد الخام",
        size: "الحجم",
        pleaseInputDeviceName: "يرجى إدخال اسم الجهاز",
        item: "بند",
        allMaterial: "كل المواد الخام",
        allDevices: "كل الأجهزة",
        "saveSuccess": "تم الحفظ بنجاح",
        "savefaill": "فشل في الحفظ",
        "playMode": "وضع التشغيل",
        "cyclePlay": "التشغيل الدوري",
        "insertPlay": "التشغيل الإدخالي",
        "noData": "لا توجد بيانات",
        "Add": "إضافة جديدة",
        "replace": "استبدال",
        "repeat": "تكرار",
        "start01": "بدء",
        "end01": "نهاية",
        "startDate": "تاريخ البدء",
        "endDate": "تاريخ الانتهاء",
        "useNow": "استخدام فوري",
        "fillStartEndTimeFirst": "يرجى ملء وقت البدء والانتهاء قبل الإضافة",
        "fillFullPlayTime": "يرجى ملء وقت التشغيل الكامل",
        "fillCorrectPlayTime": "يرجى ملء فترة وقت التشغيل الصحيحة",
        "sDateAndEDateBothEmptyOrFilled": "يجب أن يكون تاريخ البدء وتاريخ الانتهاء فارغين معًا أو مملوءين معًا"
    },
    source: {
        addResource: "إضافة موارد",
        width: "العرض",
        height: "الارتفاع",
        size: "الحجم (KB)",
        name: "الاسم",
        pleaseInputResourceName: "يرجى إدخال اسم المورد！",
        addToGroup: "إضافة إلى المجموعة",
        remark: "ملاحظات",
        promptFgIllustrate: "رسم توضيحي",
        promptFgRealisticPhoto: "صورة واقعية",
        promptFgSimplisticDrawing: "رسم بسيط",
        promptFgChineseStyle: "أسلوب صيني",
        promptFgPixelArt: "فن بكسل",
        noModel: "لا توجد نماذج، يرجى الاتصال بالمشرف！",
        getModelFailed: "فشل الحصول على النموذج، يرجى المحاولة مرة أخرى لاحقًا！أو الاتصال بالمشرف！",
        createImagePrompt: "جاري إنشاء الصورة، يرجى الإغلاق لاحقًا！",
        promptEmpty: "يرجى إدخال النص التوجيهي",
        dpiEmpty: "يرجى اختيار نسبة الصورة！",
        fgEmpty: "يرجى اختيار الأسلوب！",
        style: "الأسلوب",
        idEmpty: "معرف الصورة لا يمكن أن يكون فارغاً",
        exist: "هذه الصورة موجودة بالفعل في المواد الخام",
        addSuccess: "تم إضافة المواد الخام بنجاح",
        saveError: "فشل حفظ الصورة， يرجى المحاولة مرة أخرى لاحقًا！",
        delSuccess: "تم الحذف بنجاح",
        generateImage: "توليد صورة من نص",
        generateImagePlaceholder: 'يرجى إدخال الصورة التي تريد إنشائها، على سبيل المثال: فراشة ترقص في حقل من الزهور',
        aiExpand: "التمديد الذكي",
        negativePrompt: "النص التوجيهي السلبي",
        negativePromptTooltip: "يستخدم لتحديد استبعاد المحتوى أو الخصائص التي لا يريد المستخدم رؤيتها في المخرجات",
        imageRatio: "نسبة الصورة",
        generateImageBtn: "إنشاء فورًا",
        shengchengjieguo: "نتيجة الإنشاء",
        generateImageLoadingTip: "جاري الإنشاء، لا تضغط مرتين أو أغلق...",
        Tooltip: "هيا بنا نصنع إبداعك بالذكاء الاصطناعي",
        saveToMaterial: "حفظ في المواد الخام",
        publish: "نشر فورًا",
        download: "تنزيل",
        generateHistory: "تاريخ الإنشاء",
        hide: "تقليب",
        cancel: "إلغاء",
        useExpand: "استخدام التمديد",
        all: "الكل",
        delete: "حذف",
        loadMore: "تحميل المزيد",
        aiTip: "المحتوى تم إنشاؤه بواسطة نموذج الذكاء الاصطناعي، ولا يمثل وجهة النظر أو الموقف أو الموقف من المنصة، يرجى استخدام المحتوى الاصطناعي بشكل قانوني وملائم",
        operationSuccess: "تم العملية بنجاح",
        moveGroup: "نقل المجموعة",
        groupName: "اسم المجموعة",
        pleaseSelectGroup: "يرجى اختيار اسم المجموعة！",
        shenhe: "مراجعة",
        shenheStatus: "حالة المراجعة",
        shenheSuccess: "تمت المراجعة بنجاح",
        shenheRefuse: "تم رفض المراجعة",
        pleaseSelectShenheStatus: "يرجى اختيار حالة المراجعة！",
        shenheRemark: "ملاحظات المراجعة",
        pleaseInputShenheRemark: "يرجى إدخال ملاحظات المراجعة！",
        pleaseInputFileName: "يرجى إدخال اسم الملف！",
        whitespace: "خطأ في التسمية， لا يمكن أن يحتوي اسم الملف على مسافات！",
        dataError: "البيانات غير صحيحة！",
        confirmDelete: "تأكيد الحذف",
        confirm: "تأكيد",
        deleteFolder: "حذف المجلد",
        add: "إضافة",
        edit: "تحرير",
        fileName: "اسم الملف",
        group: "المجموعة",
        resolution: "الدقة",
        type: "النوع",
        image: "صورة",
        music: "موسيقى",
        video: "فيديو",
        uploadTime: "وقت الرفع",
        uploadUser: "المرفع",
        checkTime: "وقت المراجعة",
        checkUser: "المراجع",
    },
    setting: {
        nameempty: "الاسم لا يمكن أن يكون فارغاً",
        heightempty: "الارتفاع لا يمكن أن يكون فارغاً",
        widthempty: "العرض لا يمكن أن يكون فارغاً",
        resolutionratio: "الدقة",
        name: "الاسم",
        opteration: "العمليات",
        compile: "تحرير",
        delete: "حذف",
        newz: "إضافة جديدة",
        compileratio: "تحرير الدقة",
        sheizhifenbianlvmingcheng: "تعيين اسم الدقة",
        shezhigaodu: "تعيين الارتفاع",
        shezhikuandu: "تعيين العرض",
        xinzengfenbianlv: "إضافة دقة جديدة",
        bianma: "ترميز",
        bianjizhongduanmingcheng: "تحرير اسم الطرفية",
        xinzengzhongduan: "إضافة طرفية جديدة",
        selectPrimaryColor: 'اختيار لون السمة',
        fullScreen: 'ملء الشاشة',
        exitFullScreen: 'خروج من ملء الشاشة',
    },
    tabs: {
        refresh: 'تحديث',
        refreshAll: 'تحديث الكل',
        close: 'إغلاق',
        closeOthers: 'إغلاق الأخرى',
        closeAll: 'إغلاق الكل',
        closeLeft: 'إغلاق اليسار',
        closeRight: 'إغلاق اليمين',
    },
    errorPage: {
        needLogin: 'لم تقم بتسجيل الدخول بعد！',
        pageNotFound: 'الصفحة التي تزورها غير موجودة！',
        redirectTo: 'إعادة التوجيه إلى',
        orReturn: 'أو العودة إلى',
        previousStep: 'الخطوة السابقة',
    },
    headerUs: {
        systemNotice: "إخطارات النظام",
        allNotices: "كل الإخطارات",
        viewAllMessages: "عرض جميع الرسائل",
        contactUs: "اتصل بنا",
        operationSuccess: "تم العملية بنجاح！",
        leaveMessage: "أريد ترك رسالة",
        messageTitle: "العنوان",
        messageTitleTip: "يرجى إدخال العنوان！",
        messageContentTip: "150 حرفًا كحد أقصى",
        submit: "إرسال",
        markAsRead: "تحديد كقراءة",
        success: "تم العملية بنجاح！"
    },
    material: {
        allMaterial: "كل المواد الخام",
        defaultGroup: "المجموعة الافتراضية",
        auditStatus: "حالة المراجعة",
        auditPassed: "تمت المراجعة بنجاح",
        auditRejected: "تم رفض المراجعة",
        pendingAudit: "في انتظار المراجعة",
        all: "الكل",
        operateSuccess: "تم العملية بنجاح！",
        pleaseSelectMaterial: "يرجى اختيار المواد الخام！",
        moveGroup: "نقل المجموعة",
        pleaseSelectGroup: "يرجى اختيار المجموعة！",
        batchPublish: "نشر جماعي",
        batchRecall: "سحب جماعي",
        batchDelete: "حذف جماعي",
        materialList: "قائمة المواد الخام",
        uploadMaterial: "رفع المواد الخام",
        materialType: "نوع المواد الخام",
        pleaseInputMaterialName: "يرجى إدخال اسم المواد الخام",
        selectAll: "تحديد الكل",
        confirmDeleteSelectedMaterial: "هل تؤكد حذف المواد الخام المختارة؟",
        deleteSuccess: "تم الحذف بنجاح",
        delete: "حذف",
        publish: "نشر",
        recall: "سحب",
        confirmRecallSelectedMaterial: "هل تؤكد سحب المواد الخام المختارة؟",
        pleaseSelectMaterialGroup: "يرجى اختيار مجموعة المواد الخام！",
        recallSuccess: "تم السحب بنجاح",
        publishSuccess: "تم النشر بنجاح",
        batchOperate: "العمليات الجماعية",
        item: "بند",
        confirmDelete: "هل تؤكد الحذف؟",
        edit: "تحرير",
        confirmRecall: "هل تؤكد السحب؟",
        unaudited: "غير مراجع",
        notPassed: "غير ممرور",
        operate: "العمليات",
        resolution: "الدقة",
        none: "لا شيء",
        confirm: 'تأكيد',
        cancel: 'إلغاء',
        AICreation: "الإبداع بالذكاء الاصطناعي",
    },
    uploadFile: {
        operationSuccess: "تم العملية بنجاح",
        uploadFile: "إدارة الرفع",
        uploadSuccess: "تم الرفع بنجاح",
        uploadCompleted: "تم الرفع",
        uploadFail: "فشل الرفع",
        ConversionFailed: "فشل التحويل！",
        loading: "جاري التحميل بجد...",
        beQueuing: "في قائمة الانتظار...",
        Uploading: "جاري الرفع...",
        ConversionIng: "جاري التحويل...",
        ConventionalResources: "الموارد التقليدية",
        DocumentResources: "موارد المستندات",
        complete: "إكمال",
        upload: "رفع",
        fileSizeWraning01: "حجم المواد الخام يتجاوز",
        fileSizeWraning02: "يرجى تعديلها ثم إعادة الرفع！",
        fileIsEmpty: "الملف فارغ",
        uploadFileTip: "تنسيق الملف غير مدعوم",
        unablePreview: "لم تتم إضافتها بنجاح إلى مكتبة المواد الخام، لا يمكن المعاينة",
        confirmDelete: "هل تؤكد الحذف؟",
        deleteSuccess: "تم الحذف بنجاح",
        delete: "حذف",
        confirm: "تأكيد",
        preview: "معاينة",
        close: "إغلاق",
        cancel: "إلغاء",
        fileType: "نوع الملف",
        fileSize: "حجم الملف",
        conversionProgress: "تقدم التحويل",
        progress: "التقدم",
        image: "صورة",
        video: "فيديو",
        audio: "موسيقى",
        limitTip01: "رفع مرة واحدة",
        limitTip02: "ملفات",
        okTip: "جاري رفع المواد الخام، يرجى الإغلاق لاحقًا！",
        usableSize: 'الحجم المتاح',
        sizeUnableTip: "المساحة التخزينية المتاحة الحالية غير كافية، يرجى تنظيف المواد الخام غير المفيدة في الوقت المناسب لتوفير مساحة أو الاتصال بالمتجر لزيادة الحجم.",
        view: "عرض التفاصيل",
        fileName: "اسم الملف",
    },
    template: {
        inputPlaceholder: 'يرجى الإدخال',
        selectPlaceholder: 'يرجى الاختيار',
        noAuths: "لا توجد صلاحيات، يرجى الاتصال بالمشرف",
        operationSuccess: "تم العملية بنجاح",
        total: "مجموع",
        totalNum: "بند",
        dan: "واحد",
        shaung: "اثنان",
        pleaseSelectGroup: "يرجى اختيار المجموعة",
        preview: "معاينة",
        free: "مجاني",
        use: "استخدام",
        dpi: 'الدقة',
        delete: "حذف",
        confirmDelete: "تأكيد الحذف",
        confirmDeleteSelectedTemplate: "هل تؤكد حذف هذا القالب",
        push: "نشر",
        pushConfirm: "هل تؤكد النشر إلى القالب العام؟",
        pushRemovalConfirm: "هل تؤكد سحبه من القالب العام؟",
        templateOrderRecord: "سجل طلبات القالب",
        unpublished: "غير منشور",
        auditing: "جاري المراجعة",
        publishRejected: "تم رفض النشر",
        publishSuccess: "تم النشر بنجاح",
        offShelf: "إزالة من الرف",
        公共模版: "قالب عام",
        我的模板: "قالبي",
        共享记录: "سجل المشاركة",
        name: "الاسم",
        pubdate: "وقت النشر",
        keySeachTip: "يرجى إدخال الكلمة الرئيسية",
        allGroup: "كل المجموعات",
        add: "إضافة",
        edit: "تحرير",
        programName: "اسم البرنامج",
        selectGroup: "اختيار المجموعة",
    },
    checkManage: {
        total: "مجموع",
        totalNum: "بند",
        operationSuccess: "تم العملية بنجاح",
        checkUserLogs: "سجلات المراجعة (المشغل)",
        checkLogs: "سجلات المراجعة (المراجع)",
        sourceCheck: "مراجعة المواد الخام",
        programCheck: "مراجعة البرامج",
        checkAll: "تحديد الكل",
        auditPass: "تمت المراجعة بنجاح",
        auditRefuse: "تم رفض المراجعة",
        auditPass01: "مجاز",
        auditRefuse01: "مرفوض",
        auditRefuse02: "رفض المراجعة",
        auditor: "المراجع",
        agentUserName: "الناشر",
        interrogationTime: "وقت التقديم للمراجعة",
        checkTime: "وقت المراجعة",
        checkName: "اسم المراجعة",
        checkType: "فئة المراجعة",
        checkIp: "عنوان IP للتقديم للمراجعة",
        checkReason: "ملاحظات",
        checkStatus: "محتوى العملية",
        rangePicker: "تاريخ المراجعة",
        keyWord: "كلمة رئيسية",
        all: "الكل",
        program: 'البرنامج',
        material: 'المواد الخام',
        dan: "واحد",
        shaung: "اثنان",
        pleaseSelectProgram: "يرجى اختيار البرنامج!",
        pleaseSelectMaterial: "يرجى اختيار المواد الخام！",
        preview: "معاينة",
        dpi: 'الدقة',
        auditRefuseTip: "يرجى إدخال سبب الرفض",
        unreviewed: "غير مراجع",
        notPassed: "غير ممرور",
        notUsed: "غير مستخدم",
        edit: "تحرير",
        none: "لا شيء",
        name: "الاسم",
        size: "الحجم",
        type: "النوع",
        uploadTime: "وقت الرفع",
        uploadUser: "المرفع",
        checkUser: "المراجع",
        image: "صورة",
        music: "موسيقى",
        video: "فيديو",
    },
    systemSet: {
        total: "مجموع",
        totalNum: "بند",
        inputPlaceholder: 'يرجى الإدخال',
        selectPlaceholder: 'يرجى الاختيار',
        userList: "أعضاء المنظمة",
        roleList: "صلاحيات الدور",
        department: "هيكل المنظمة",
        diskInfo: "المساحة التخزينية",
        approveSet: "موافقة المحتوى",
        logList: "إدارة السجلات",
        name: "الاسم",
        account: "الحساب",
        userName: "اسم المستخدم",
        phoneNumber: "رقم الهاتف المحمول",
        role: "الدور",
        createTime: "وقت الإنشاء",
        operation: "العمليات",
        edit: "تحرير",
        delete: "حذف",
        addNew: "إضافة جديدة",
        add: "إضافة",
        resetPassword: "إعادة تعيين كلمة المرور",
        confirmDelete: "تأكيد الحذف",
        departmentOrganization: "قسم الجهة",
        addNewUser: "إضافة مستخدم جديد",
        pleaseEnterUserName: "يرجى إدخال اسم المستخدم",
        confirmPasswordNotMatch: "تأكيد كلمة المرور مختلف عن كلمة المرور المدخلة!",
        operationSuccess: "تم العملية بنجاح！",
        userNickname: "اسم المستخدم",
        pleaseEnterUserNickname: "يرجى إدخال اسم المستخدم",
        userNicknameRequired: "اسم المستخدم لا يمكن أن يكون فارغاً！",
        password: "كلمة المرور",
        pleaseEnterPassword: "يرجى إدخال كلمة المرور",
        passwordRequired: "كلمة المرور لا يمكن أن تكون فارغة！",
        passwordTip: "أمان كلمة المرور منخفض جدًا (يجب أن تحتوي كلمة المرور على 3 أنواع من بين الأحرف الكبيرة، الأحرف الصغيرة، الأرقام، الأحرف الخاصة، وطولها 8 حرفًا على الأقل)",
        confirmPassword: "تأكيد كلمة المرور",
        pleaseEnterPhoneNumber: "يرجى إدخال رقم الهاتف المحمول",
        phoneNumberRequired: "رقم الهاتف المحمول لا يمكن أن يكون فارغاً！",
        phoneNumberFormatError: "يرجى إدخال تنسيق رقم الهاتف المحمول الصحيح！",
        roleRequired: "الدور لا يمكن أن يكون فارغاً！",
        required: "لا يمكن أن يكون فارغاً！",
        departmentName: "القسم",
        modifyPassword: "تغيير كلمة المرور",
        newPassword: "كلمة المرور الجديدة",
        pleaseEnterNewPassword: "يرجى إدخال كلمة المرور الجديدة",
        pwdMessage: "طول كلمة المرور 8~20 حرفًا، لا يمكن أن يحتوي على مسافات ويجب أن يحتوي على 3 من أنواع الأحرف التالية: أحرف كبيرة، أحرف صغيرة، أرقام، أحرف خاصة",
        all: "الكل",
        noAuths: "لا توجد صلاحيات، يرجى الاتصال بالمشرف",
        departmentName01: "اسم القسم",
        image: "صورة",
        music: "موسيقى",
        video: "فيديو",
        buySize: "الكمية المشتراة",
        totalMoney: "المبلغ المدفوع",
        buycreateTime: "وقت الشراء",
        endTime: "وقت انتهاء الصلاحية",
        buyTypeStr: "نوع الطلب",
        sourceCheck: "مراجعة المواد الخام",
        programCheck: "مراجعة البرامج",
        programName: "اسم البرنامج",
        diskExpansion: "يوصى بتنظيف المواد الخام المنتهية الصلاحية/غير المستخدمة في الوقت المناسب أثناء الاستخدام لضمان سعة النظام المتاحة. إذا كنت بحاجة إلى مساحة أكبر، يمكنك الاتصال بمزود الأجهزة للحصول على خدمة توسيع سعة مساحة التخزين السحابية. قد تُفرض رسوم على هذه الخدمة، يرجى الاعتماد على معلومات التاجر في هذا الصدد.",
        selectPermission: "يرجى اختيار الصلاحيات",
        checkPermission: "يرجى تحديد الصلاحيات",
        addRole: "إضافة دور",
        enterRoleName: "يرجى إدخال اسم الدور",
        roleName: "اسم الدور",
        roleNameRequired: "اسم الدور لا يمكن أن يكون فارغاً！",
        remark: "ملاحظات",
        enterRemark: "يرجى إدخال الملاحظات",
        permissionSetting: "إعدادات الصلاحيات",
        deleteSuccess: "تم الحذف بنجاح！",
        confirmToDelete: "هل تؤكد الحذف؟",
        orgName: "اسم الجهة",
        orgNameRequired: "اسم الجهة لا يمكن أن يكون فارغاً！",
        orgRemark: "ملاحظات الجهة",
        enterOrgRemark: "يرجى إدخال ملاحظات الجهة",
        capacityUsage: "حالة استخدام السعة",
        usedCapacity: "السعة المستخدمة",
        totalCapacity: "السعة الكلية",
        remainingCapacity: "السعة المتبقية",
        capacityExpansion: "توسيع السعة",
        enable: "تفعيل",
        disable: "تعطيل",
        userName01: "اسم المستخدم",
        loginTime: "وقت تسجيل الدخول",
        ipAddress: "عنوان IP",
        loginResult: "نتيجة تسجيل الدخول",
        selectDate: "اختيار التاريخ",
        enterDate: "يرجى اختيار التاريخ",
        selectStartTime: "يرجى اختيار وقت البدء",
        selectEndTime: "يرجى اختيار وقت الانتهاء",
        enterUserName: "يرجى إدخال اسم المستخدم",
        userCount: "عدد المستخدمين",
        roleDesc: "وصف الدور",
        roleAuthorization: "تمكين الدور",
        success: "نجاح",
        failure: "فشل",
        time: "الوقت",
        operationContent: "محتوى العملية",
        playCount: "عدد المرات التي تم تشغيلها",
        playDuration: "مدة التشغيل",
        selectDevice: "اختيار الجهاز",
        enterProgramName: "يرجى إدخال اسم البرنامج",
        serialNumber: "الرقم التسلسلي",
        publishContentName: "اسم محتوى النشر",
        playMode: "طريقة التشغيل",
        cyclePlay: "التكرار الدوري",
        insertPlay: "التشغيل الإدخالي",
        paddingPlay: "التشغيل التكميلي",
        playDeviceId: "معرف جهاز التشغيل",
        playDeviceName: "اسم جهاز التشغيل",
        publishTime: "وقت النشر",
        downloadStatus: "حالة التنزيل",
        notDownloaded: "لم يتم التنزيل",
        downloading: "جاري التنزيل",
        downloadSucceeded: "تم التنزيل بنجاح",
        downloadFailed: "فشل التنزيل",
        enterPublishContentName: "يرجى إدخال اسم محتوى النشر",
        terminalId: "معرف الطرفية",
        belongOrg: "الجهة التابعة",
        reportTime: "وقت الإرسال",
        reportIp: "IP للإرسال",
        logInfo: "معلومات السجل",
        details: "التفاصيل",
        confirmDeletion: "هل تؤكد الحذف؟",
        logDetails: "تفاصيل السجل",
        download: "تنزيل",
        deptOrg: "قسم الجهة",
        query: "استعلام",
        queryByTerminalId: "استعلام حسب معرف الطرفية",
        batchDeleteLogs: "حذف السجلات جماعيًا",
        customTimeDeleteLogs: "حذف السجلات حسب وقت مخصص",
        selectTimeRangeFirst: "يرجى اختيار نطاق الوقت أولاً",
        deleteAllDeviceLogsIfEmpty: "إذا لم تملأ معرف الجهاز، سيتم حذف سجلات جميع الأجهزة افتراضيًا",
        enterDeviceIdToDeleteLogs: "يرجى إدخال معرف الجهاز لحذف سجلاته",
        confirmDeleteAction: "تأكيد الحذف",
        selectDeleteRangeFirst: "يرجى اختيار نطاق الحذف أولاً",
        networkConnectionFailed: "فشل اتصال الشبكة",
        playLog: "سجل التشغيل",
        publishLog: "سجل النشر",
        errorLog: "سجل الأخطاء",
        operationLog: "سجل العمليات",
        fileLog: "سجل الملفات",
        userOperateLog: "سجل تسجيل الدخول",
    },
    userManual: {
        userManual: "دليل المستخدم",
        noData: "لا توجد بيانات",
    },
    systemNotice: {
        systemNotice: "إخطارات النظام",
        noData: "لا توجد بيانات",
        total: "مجموع",
        totalNum: "بند",
        "markAllRead": "تحديد الكل كقراءة",
        "deleteAll": "حذف الكل",
        "all": "الكل",
        "unread": "غير مقرأ",
        "read": "مقرأ",
        "type": "النوع",
        "content": "المحتوى",
        "date": "التاريخ",
        "status": "الحالة",
        "confirmDelete": "هل تؤكد الحذف؟",
        "confirm": "تأكيد",
        "cancel": "إلغاء",
        "delete": "حذف"
    }
};